module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/effects-and-pedals-8903eec83059c401fbf17c418cfc0d6b.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/effects-and-pedals.png
// module id = abrg
// module chunks = 12 16 18